'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('bhired_benchmark', {
      url: '/bhired_benchmark',
      template: '<bbenchmarktab></bbenchmarktab>'
    });
}
